import heroPortrait from "@/assets/hero-portrait.jpg";
import { trackEvent } from "@/lib/analytics";

const Hero = () => {
  return (
    <section id="top" className="relative pt-16 pb-24 md:pt-24 md:pb-32 px-6 md:px-10 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-warm pointer-events-none" />
      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 space-y-10 animate-fade-up">
          <span className="inline-block px-5 py-2 border border-accent/40 rounded-full text-[10px] tracking-[0.3em] uppercase text-accent font-medium">
            London · Preferred Rates
          </span>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[1.05] text-foreground text-balance">
            Blepharoplasty London —
            <br />
            <span className="italic text-accent">Eyes, Awakened.</span>
          </h1>

          <p className="max-w-[52ch] text-lg md:text-xl leading-relaxed text-muted-foreground font-light text-pretty">
            Dr Vahe's signature blepharoplasty in London — a refined, restorative approach to
            the upper and lower eyelids, designed to reveal a more rested, naturally vibrant
            version of you. Available at our London surgical suite with preferred promotional rates.
          </p>

          <div className="flex flex-wrap gap-10 pt-2">
            <div>
              <p className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-2">
                Upper Blepharoplasty
              </p>
              <p className="font-display text-4xl text-foreground">
                £2,300
                <span className="text-sm line-through opacity-40 ml-3 italic font-sans">£3,200</span>
              </p>
            </div>
            <div className="w-px h-14 bg-border self-end hidden sm:block" />
            <div>
              <p className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-2">
                Upper & Lower
              </p>
              <p className="font-display text-4xl text-foreground">
                £3,100
                <span className="text-sm line-through opacity-40 ml-3 italic font-sans">£4,200</span>
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-6 pt-4">
            <a
              href="#booking"
              onClick={() => trackEvent("cta_book_click", { location: "hero", label: "Request a Consultation" })}
              className="inline-flex items-center justify-center px-10 py-5 bg-primary text-primary-foreground rounded-full text-xs uppercase tracking-[0.3em] hover:bg-accent transition-all duration-500 shadow-soft"
            >
              Request a Consultation
            </a>
            <p className="text-xs italic text-muted-foreground font-display">
              Preferred rates · Subject to consultation
            </p>
          </div>
        </div>

        <div className="lg:col-span-5 relative animate-fade-in">
          <div className="aspect-[4/5] bg-linen-deep rounded-[40px] overflow-hidden shadow-elegant">
            <img
              src={heroPortrait}
              alt="Restored, naturally radiant skin around the eyes"
              className="w-full h-full object-cover"
              width={800}
              height={1000}
              fetchPriority="high"
              decoding="async"
            />
          </div>
          <div className="absolute -bottom-10 -left-6 md:-left-10 bg-card p-7 md:p-8 rounded-2xl shadow-soft border border-border/60 max-w-[280px]">
            <p className="font-display text-lg md:text-xl leading-snug text-foreground italic">
              "A quiet restoration of the self. I look like me again — only rested."
            </p>
            <p className="mt-4 text-[10px] uppercase tracking-[0.3em] text-accent font-medium">
              — Patient · Knightsbridge
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
